"use client"

import { format, parseISO } from "date-fns"
import { CalendarIcon } from "lucide-react"
import { DateRange } from "react-day-picker"

import { cn } from "src/utils/utils"
import Button from "./button.component.tsx"
// import Calendar from "./calendar.component.tsx"

import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "./popover.components.tsx"
import { Calendar } from "src/features/fields/components/Calender.tsx"

interface DatePickerWithRangeProps {
    className?: string;
    date: DateRange | undefined;
    // setDate: React.Dispatch<React.SetStateAction<DateRange | undefined>>;
    dateRangeHandler: (details: DateRange | undefined) => void;
}

export function DatePickerWithRange({
    className,
    date,
    // setDate,
    dateRangeHandler,
}: DatePickerWithRangeProps) {

    // const dateRangeHandler = (details: DateRange | undefined) => {

    //     if (details?.from) {
    //         const fromDate = new Date(details.from);
    //         const toDate = details.to ? new Date(details.to) : undefined;

    //         const isSameDate = toDate && fromDate.getTime() === toDate.getTime();

    //         const payload: DateRange = {
    //             from: fromDate.toISOString() as any,
    //             ...(toDate && !isSameDate && { to: toDate.toISOString() as any }),
    //         };
    //         // dispatch(invoiceActions.setInvoiceFilters({ key: "dateRange", value: payload }));
    //         setDate(payload);
    //     }
    // };

    return (
        <div className={cn("grid gap-2", className)}>
            <Popover>
                <PopoverTrigger asChild>
                    <Button
                        id="date"
                        // variant={"outline"}
                        className={cn(
                            "w-[300px] justify-start text-left font-normal",
                            !date && "text-muted-foreground"
                        )}
                    >
                        {date?.from ? (
                            date.to ? (
                                <>
                                    {format(typeof date.from === "string" ? parseISO(date.from) : date.from, "LLL dd, y")} -{" "}
                                    {format(typeof date.to === "string" ? parseISO(date.to) : date.to, "LLL dd, y")}
                                </>
                            ) : (
                                format(typeof date.from === "string" ? parseISO(date.from) : date.from, "LLL dd, y")
                            )
                        ) : (
                            <span>Pick a date</span>
                        )}
                        <div className="flex items-center justify-center ml-2 w-5 h-5">
                            <CalendarIcon />
                        </div>
                    </Button>
                </PopoverTrigger>
                <PopoverContent className="w-auto p-0" align="start">
                    <Calendar
                        className="w-full bg-white"
                        classNames={{
                            today: `border border-[#8051FF]`,
                            selected: `bg-[#ded9ff] border-[#8051FF] font-semibold`, // Highlight the selected day
                            root: `border border-[#D0D0D0] rounded-xl p-5 flex items-center justify-center text-[1rem]`, // Add a shadow to the root element
                            day: `p-2 cursor-pointer`, // Base styles for each day
                            chevron: `fill-[#7F56D9] hover:fill-[#8051FF] transition-colors`, // Change the color of the chevron
                            outside: `text-gray-400`,
                            nav: `flex items-start`,
                        }}
                        initialFocus
                        mode="range"
                        defaultMonth={date?.from}
                        selected={date}
                        onSelect={dateRangeHandler}
                        numberOfMonths={2}
                    />
                </PopoverContent>
            </Popover>
        </div>
    )
}
